/*
 * @Author: hujiajun
 * @Date: 2021-03-10 09:03:39
 * @LastEditTime: 2021-06-25 15:44:52
 * @LastEditors: Do not edit
 * @FilePath: \FullPhotoViewer\src\api\public.js
 * @Description: 
 */
import axios from 'axios';
import { getQuery, getStore, replaceParamVal } from '@/utils';
import config from '@/config';
import { Modal, Spin } from 'view-design';
// const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;
const baseUrl = ''
axios.defaults.baseURL = baseUrl;

import router from '@/router';
// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
    return status >= 200 && status <= 500 // 默认的
  }
// 添加请求拦截器
axios.interceptors.request.use(
    config => {
        if (getQuery('tokenId')) {
            config.headers['tokenid'] = getStore({
                name: 'access_token',
                type: 'session'
            }) || getQuery('tokenId') // 让每个请求携带token--['tokenid']为自定义key 请根据实际情况自行修改
        }
        if (config.url == '/render/Tour/UpdateTour' || config.url == '/render/Tour/SaveDesignerInfoExtend') {
            config.headers = {
                'Content-Type':'application/x-www-form-urlencoded'
            };
        }
        if (config.url == '/admin/user/checkCaxaToken') {
            config.headers = {
                'Content-Type':'application/x-www-form-urlencoded',
                'isToken': false,
                'Authorization': 'Basic YmJzOmJicw=='
            };
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(res => {
    const { data, status } = res;
    const accessToken = getStore({
        name: "access_token",
        type: 'session'
    });
    const tokenId = getQuery('tokenId')
    // 统一错误处理
    // 登录过期
    if (!data.IsSuccess && data.ErrorMessage == 'TokenIdTimeOut') {
        Modal.error({
            title: '登录过期',
            content: '请重新登录设计软件再进行全景方案编辑'
        });
        Spin.hide();
    }
    // /apiV1/admin/user/checkCaxaToken 接口调用时当tokenId是过期也返回200接口，无法通过返回的msg信息区分，
    // 目前通过返回值data来判断，如果tokenId值未过期，data里面有值，tokenId过期，data里面无值
    // /apiV1/admin/user/checkCaxaToken 接口只在路由转换时候触发
    if(res.config.url == '/apiV1/admin/user/checkCaxaToken') {
        if (!res.data.data.access_token && tokenId !== accessToken && accessToken) {
            let href = replaceParamVal(location.href, "tokenId", accessToken);
    	    location.replace(href);
        }
    }
    // tokenId和accessToken不等时，说明url里面的值还是从设计软件或官网打开全景时携带的，这时候如果接口返回
    // 返回 User credentials have expired，可以用/apiV1/admin/user/checkCaxaToken接口返回的accesToken
    // 替换掉url里面的tokenId从新加载一次，当url里面的tokenId和accessToken 相等时候，说明已经
    // 用/apiV1/admin/user/checkCaxaToken 接口里面获取的accessToken替换过 url里面的tokenId值
    if(data.msg == 'User credentials have expired' || data.msg == '用户凭证已过期') {
        if (accessToken && tokenId !== accessToken) {
            let href = replaceParamVal(location.href, "tokenId", accessToken);
    	    location.replace(href);
        } else {
            Modal.error({
                title: '登录过期',
                content: '请重新登录设计软件再进行全景方案编辑'
            });
            Spin.hide();
        }
        
    }
    // if (status !== 200 && status !== 204 || res.data.code === 1) {
    //     Modal.error({
    //         title: '请重新打开',
    //         content: data.msg
    //     });
    //     Spin.hide();
    //     return router.replace({ path:`/exception/${data.msg}` });
    // }
    return { data, status };
},
error => {
    return Promise.reject(error);
});

// 公共
export default {
    post (url, params) {
        return new Promise((resolve, reject) => {
            axios.post('/' + url, params).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    put (url, data, contentType) {
        return new Promise((resolve, reject) => {
            axios.put(url, data,
            {withCredentials: false,headers: {
                "Content-Type": contentType,
              }}
            ).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    patch (url, params) {
        return new Promise((resolve, reject) => {
            axios.patch('/' + url, params).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete (url, params) {
        return new Promise((resolve, reject) => {
            axios.delete('/' + url, { data: params }).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    get (url, params, otherUrl) {
        return new Promise((resolve, reject) => {
            axios.get('/' + url, {
                params: params,
                otherUrl
            }).then(res => {
                resolve(res.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/public.js